export class EksternBrugerAktiveringsPublicModel {
        public invitationsPublicId: string;
        public invitationsLinkErForældet: boolean;
        public brugerErAlleredeAktiveret: boolean;
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/EksternBrugerAktiveringsPublicModel.ts